import React from 'react';
import { Button } from 'components/Button';

export const Back: React.FC = () => {
  const isPageInIframe = window.self !== window.top;
  const handleClick = () => {
    // Create a message to send
    const message = 'closeWindow';

    // Send the message to the parent window
    window.parent.postMessage(message, '*');
  };

  const renderButton = () => {
    if (isPageInIframe) return <Button onClick={handleClick}>Back</Button>;

    return (
      <a href={'https://market.tacticool.game'} rel="noreferrer">
        <Button>Back</Button>
      </a>
    );
  };

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        height: '100vh',
      }}
    >
      <h1>Back</h1>
      {renderButton()}
    </div>
  );
};
